import React, { useEffect, useState } from 'react';
import Header from "components/Header/Header.js";
import HomeFooter from "components/Footer/HomeFooter.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import {colors} from '../components/Theme/WebTheme';
import Hero from "../components/Hero";
import Section from "../components/Section";
import Download from "../components/Download";
import { Helmet } from 'react-helmet-async';

import { useSelector } from "react-redux";

const dashboardRoutes = [];

// Canonical public domain. Update here if the live canonical is www / a different TLD.
const SITE_URL = "https://tasirimkurye.com";
const BRAND = "Taşırım Kurye ve Lojistik Hizmetleri";

// All 39 İstanbul districts we serve — used for the LocalBusiness `areaServed`
// structured data. This is the semantically correct place to declare local
// coverage (vs. stuffing district names into visible copy).
const ISTANBUL_DISTRICTS = [
  "Adalar", "Arnavutköy", "Ataşehir", "Avcılar", "Bağcılar", "Bahçelievler",
  "Bakırköy", "Başakşehir", "Bayrampaşa", "Beşiktaş", "Beykoz", "Beylikdüzü",
  "Beyoğlu", "Büyükçekmece", "Çatalca", "Çekmeköy", "Esenler", "Esenyurt",
  "Eyüpsultan", "Fatih", "Gaziosmanpaşa", "Güngören", "Kadıköy", "Kağıthane",
  "Kartal", "Küçükçekmece", "Maltepe", "Pendik", "Sancaktepe", "Sarıyer",
  "Silivri", "Sultanbeyli", "Sultangazi", "Şile", "Şişli", "Tuzla",
  "Ümraniye", "Üsküdar", "Zeytinburnu",
];

const COURIER_SERVICES = [
  "Moto Kurye", "Araçlı Kurye", "Panelvan Kurye", "Minivan Kurye",
  "Aynı Gün Teslimat", "Şehir İçi Kurye", "Express Teslimat", "Acil Kurye",
];

const structuredData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": `${SITE_URL}/#business`,
  name: BRAND,
  url: SITE_URL,
  image: `${SITE_URL}/apple-icon.png`,
  description:
    "İstanbul genelinde 7/24 moto kurye, araçlı kurye ve aynı gün express teslimat hizmeti.",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Küçükbakkalköy Mah. Kocasinan Cad. Selvili Sok. 41/48",
    addressLocality: "Ataşehir",
    addressRegion: "İstanbul",
    addressCountry: "TR",
  },
  areaServed: [
    { "@type": "City", name: "İstanbul" },
    ...ISTANBUL_DISTRICTS.map((d) => ({ "@type": "AdministrativeArea", name: `${d}, İstanbul` })),
  ],
  openingHoursSpecification: {
    "@type": "OpeningHoursSpecification",
    dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
    opens: "00:00",
    closes: "23:59",
  },
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Kurye Hizmetleri",
    itemListElement: COURIER_SERVICES.map((s) => ({
      "@type": "Offer",
      itemOffered: { "@type": "Service", name: s, areaServed: { "@type": "City", name: "İstanbul" } },
    })),
  },
};

export default function LandingPage(props) {

  const auth = useSelector(state => state.auth);

  const { ...rest } = props;

  const [role, setRole] = useState();

  useEffect(() => {
    if (auth && auth.profile) {
      if(auth.profile.uid){
        let role = auth.profile.usertype;
        setRole(role);
      }
    }
  }, [auth]);

  return (
    <div style={{backgroundColor:colors.LandingPage_Background,margin:'-8px'}}>
        <Helmet>
        <html lang="tr" />
        <title>İstanbul Kurye ve Hızlı Teslimat | Taşırım Kurye</title>
        <meta name="description" content="İstanbul'da 7/24 moto kurye, araçlı kurye ve aynı gün express teslimat. Avrupa ve Anadolu yakasında güvenilir şehir içi kurye hizmeti. Hemen gönderi oluşturun." />
        <meta name="keywords" content="istanbul kurye, istanbul moto kurye, istanbul araçlı kurye, aynı gün teslimat, şehir içi kurye, express kurye, hızlı teslimat, acil kurye, panelvan kurye, minivan kurye, avrupa yakası kurye, anadolu yakası kurye, kurye uygulaması, kurye çağır, istanbul courier, same day delivery istanbul" />
        <link rel="canonical" href={SITE_URL} />
        <meta property="og:site_name" content="Taşırım Kurye" />
        <meta property="og:title" content="İstanbul Kurye ve Hızlı Teslimat | Taşırım Kurye" />
        <meta property="og:description" content="İstanbul'da 7/24 moto kurye, araçlı kurye ve aynı gün express teslimat. Hemen gönderi oluşturun." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={SITE_URL} />
        <meta property="og:image" content={`${SITE_URL}/apple-icon.png`} />
        <meta property="og:locale" content="tr_TR" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="İstanbul Kurye ve Hızlı Teslimat | Taşırım Kurye" />
        <meta name="twitter:description" content="İstanbul'da 7/24 moto kurye, araçlı kurye ve aynı gün express teslimat." />
        <meta name="twitter:image" content={`${SITE_URL}/apple-icon.png`} />
        <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
      </Helmet>
      <Header
        color="transparent"
        routes={dashboardRoutes}
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "white"
        }}
        {...rest}
      />
      <Hero role={role}/>
      <Section role={role} color={colors}/>
      <Download />
      <HomeFooter />
    </div>
  );
}
